// extracted by mini-css-extract-plugin
export default {"row":"editEvent_row__5fZp8","col":"editEvent_col__Y3pzL","card":"editEvent_card__fjxFl"};